import React from "react";
import ArrowDownIcon from "src/icons/ArrowDownIcon";
import { SORT_DIRECTIONS } from "../HyroTable.consts";
import Tooltip from "@hyro-components/Tooltip";

const SortButton = ({ direction }) => (
  <Tooltip title={direction === SORT_DIRECTIONS.ASC ? "Sort ascending" : "Sort descending"} popperStyle={{ marginBottom: "6px" }}>
    <ArrowDownIcon flip={direction === SORT_DIRECTIONS.ASC} />
  </Tooltip>
);

SortButton.displayName = "SortButton";

export default SortButton;
